module.exports = __webpack_public_path__ + "static/media/OurStory-YellowBlockMobile.57cfa41d.svg";